import styled from '@emotion/styled';
import { isEmptyText, Prismic } from '@landsbankinn/prismic';
import { device, Segment } from '@landsbankinn/ui';
import React from 'react';
import { JotForm } from '../components/jotform/JotForm';

interface IProps {
  url: Prismic.RichText;
}

const BlueSegment = styled(Segment)`
  & > div {
    padding-left: 10px;
    padding-right: 10px;
  }
  background: ${(props) => props.theme.shades.primary2};
  @media ${device.tablet} {
    & > div {
      padding-left: 44px;
      padding-right: 44px;
    }
    background: none;
  }

  iframe {
    min-height: 400px;
  }
`;

export const JotFormContainer = ({ url }: IProps) => {
  if (isEmptyText(url)) {
    return null;
  }

  return (
    <BlueSegment>
      <JotForm url={Prismic.text(url) ?? ''} />
    </BlueSegment>
  );
};
